import * as yup from 'yup';
import { EmploymentStatusType } from '@domain/constant/profile/CareerType';

const careerFormSchema = yup.object({
  company: yup.object(),
  employmentStatus: yup.string(),
  startDate: yup.string().required(),
  endDate: yup.string().when('employmentStatus', {
    is: (val: EmploymentStatusType) => val === 'RESIGN',
    then: yup
      .string()
      .when('startDate', (startDate, schema) => {
        return schema.test({
          test: (endDate: Date) => {
            return endDate >= startDate;
          },
          message: '퇴사 일자가 입사 일자보다 빠릅니다.',
        });
      })
      .required('퇴사 일자를 입력해주세요.'),
    otherwise: yup.string().notRequired(),
  }),
  jobGroup: yup.object(),
  jobTitle: yup.object(),
  employmentType: yup.object(),
});

export default careerFormSchema;
